import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight';

import { useOfferVisibility } from './useOfferVisibility';

import dibsCss from 'dibs-css';
import styles from './OfferVisibility.scss';

import { type OfferVisibility_viewer$key } from './__generated__/OfferVisibility_viewer.graphql';

export const OfferVisibility: FC<{ viewer: OfferVisibility_viewer$key }> = ({
    viewer: viewerRef,
}) => {
    const viewer = useFragment(
        graphql`
            fragment OfferVisibility_viewer on Viewer {
                ...useOfferVisibility_viewer
            }
        `,
        viewerRef
    );
    const offerVisibility = useOfferVisibility(viewer, 'desktop');

    return offerVisibility?.href ? (
        <Link
            onClick={offerVisibility.onClick}
            href={offerVisibility.href}
            className={classnames(styles.marginRight, dibsCss.selfCenter)}
            buyerLinkType="linkNoDecoration"
        >
            <div
                className={classnames([
                    dibsCss.bgShagreen100,
                    dibsCss.roundedMedium,
                    dibsCss.pxXsmall,
                    dibsCss.py2px,
                    dibsCss.whitespaceNowrap,
                    dibsCss.sassyFontBodyTypeHeavySizeSmall,
                    dibsCss.justifyBetween,
                    dibsCss.itemsCenter,
                    dibsCss.flex,
                    dibsCss.gap2px,
                    styles.tabletStyles,
                ])}
            >
                {offerVisibility.copy} <ArrowRight className={dibsCss.h10px} />
            </div>
        </Link>
    ) : null;
};
